import { StanCard } from '@/components';
import { REFERRAL_METHODS } from '../constants/referrals.constants';

export const ReferralHowTo = () => {
    return (
        <StanCard className='w-full'>
            <h2 className='text-dark text-heading-h2 mb-8 text-center'>3 easy ways to earn</h2>

            <div className='grid w-full grid-cols-1 gap-8 text-center md:grid-cols-3'>
                {REFERRAL_METHODS.map(method => (
                    <div className='bg-canvas flex flex-col items-center gap-6 px-8' key={method.number}>
                        <div className='bg-neutral-subtle text-dark flex size-8 shrink-0 items-center justify-center rounded-full text-sm leading-none'>
                            {method.number}
                        </div>

                        <div className='flex flex-col items-center gap-4'>
                            <h3 className='text-dark text-heading-h4'>{method.title}</h3>
                            <p className='text-gray text-body-md'>{method.description}</p>
                            <div className='mt-auto flex w-full items-end justify-center'>
                                <img
                                    src={method.image}
                                    alt={method.alt}
                                    className='h-auto w-full max-w-[200px] rounded-xl object-cover'
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </StanCard>
    );
};
